<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Support Us">
                    <FormRow inline>
                        <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/>
                    </FormRow>
                    <AmountSelectorList/>
                    <ErrorLabel field="amount" />
                    <TransactionFee />
                    <br/>
                    <FormRow inline>
                      <FormCol field="">
                        <label class="control-label">I want to earmark my donation for</label>
                        <FormSelect field="custom.subDesignation">
                          <option selected="selected" value="">General Zula</option>
                          <option value="Liba Banim">Liba Banim</option>
                          <option value="Liba Banot">Liba Banot</option>
                          <option value="Zusha">Midreshet Zusha</option>
                        </FormSelect>
                      </FormCol>
                    </FormRow>
                    <InHonorOfOuisrael />
                </FormSection>
                <FormSection title="Donation Frequency">
                  <div class="frequency">
                    <PaymentOptions addSplit addMonthly monthlyText="Monthly" />
                  </div>
                </FormSection>

                <FormSection title="Your Details">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow>
                </FormSection>
                <FormSection title="Billing Information">
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                  <FormRow>
                    <Receipt />
                  </FormRow>
                  <FormRow inline>
                    <FormCol field="card" :showLabel="false" />
                  </FormRow>
                </FormSection>

                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { usePaymentForm } from '@/shared/use-payment-form';
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch
} from 'vue'

export default defineComponent({
  setup() {
    const { getValue, setValue } = usePaymentForm();

    watch(
      () => getValue("custom.subDesignation"),
      (val) => {
        if (val == "Liba Banim") {
          setValue("applications.0.subCampaign", "Liba Banim");
        } else if (val == "Liba Banot") {
          setValue("applications.0.subCampaign", "Liba Banot");
        } else if (val == "Zusha") {
          setValue("applications.0.subCampaign", "Zusha");
        } else {
          setValue("applications.0.subCampaign", "");
        }
      }
    );

    return {
      getValue,
      setValue,
    };
  },
});
</script>

<style scoped lang="scss">

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
.control-label {
  font-size: 14px;
  color: #222;
  display: block;
  margin-bottom: 5px;
}
</style>
